<!-- 任务完成情况 -->
<template>
    <div>
        <div class="form-group">
            <!-- 菜单栏 -->
            <div style="margin-top: 25px; margin-bottom: 25px">
                <el-form :inline="true" :model="formData">
                    <el-form-item label="">
                        <el-input style="width: 200px" v-model="formData.taskName" placeholder="任务名称 - 支持模糊查"
                            clearable />
                    </el-form-item>
                    <el-form-item label="">
                        <el-input style="width: 200px" v-model="formData.patch" placeholder="输入数据批次" clearable />
                    </el-form-item>
                    <el-form-item label="">
                        <el-select v-model="tempplatformList" style="width: 200px" clearable filterable multiple>
                            <el-option v-for="item in sourcesLsit" :key="item.id" :label="item.platformName"
                                :value="item.platformName" />
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="gettaskList()">查询</el-button>
                    </el-form-item>
                </el-form>
            </div>
            <!-- 数据列表 -->
            <el-table :data="managerList" :header-row-style="{ color: 'white' }" border stripe>
                <!-- <el-table-column label="序号">
                    <template #default="scope">
                        {{ scope.$index + 1 }}
                    </template>
</el-table-column> -->
                <!-- 展示 -->
                <el-table-column label="任务名称" min-width="120px" align="center" header-align="center">
                    <template #default="scope">
                        <!-- 生产测试后端传回的数据不同 -->
                        {{ scope.row.templateName == null ? scope.row.taskName : scope.row.templateName }}
                    </template>
                </el-table-column>
                <!-- 创建时间 -->
                <el-table-column label="创建时间" min-width="120px" align="center" header-align="center">
                    <template #default="scope">
                        <!-- 生产测试后端传回的数据不同 -->
                        {{ scope.row.createdTime }}
                    </template>
                </el-table-column>
                <!-- 展示 -->
                <el-table-column label="数据批次" min-width="120px" align="center" header-align="center">
                    <template #default="scope">
                        {{ scope.row.patch }}
                    </template>
                </el-table-column>
                <el-table-column label="对应平台" min-width="100px" align="center" header-align="center">
                    <template #default="scope">
                        <div style="display: flex">
                            <img class="profile-img" v-for="item in platformList(scope.row.platform)" :key="item"
                                :src="item" alt="" style="height: 40px" />
                        </div>
                    </template>
                </el-table-column>
                <!-- 展示 -->
                <el-table-column label="总筛出数" min-width="60px" align="center" header-align="center">
                    <template #default="scope">
                        {{ scope.row.filterTotal }}
                    </template>
                </el-table-column>
                <el-table-column label="已审核数" min-width="60px" align="center" header-align="center">
                    <template #default="scope">
                        {{ scope.row.hasFinished }}
                    </template>
                </el-table-column>
                <el-table-column label="未审核数" min-width="60px" align="center" header-align="center">
                    <template #default="scope">
                        {{ scope.row.filterTotal - scope.row.hasFinished }}
                    </template>
                </el-table-column>
                <!-- 审核情况 -->
                <el-table-column label="各人情况" min-width="100px" align="center" header-align="center">
                    <template #default="scope">
                        <el-button link type="primary"
                            @click="getpersondetail(scope.row.id, scope.row.platform, scope.row)"> 查看详情({{
                            scope.row.operatorCount }}人) </el-button>
                    </template>
                </el-table-column>

                <!-- 价格计算进度 -->
                <el-table-column label="计算进度" width="100px" align="center" header-align="center">
                    <template #default="scope">
                        <el-button link type="primary" @click="getCalculatedata(scope.row.id, scope.row.patch)"> 查看详情
                        </el-button>
                    </template>
                </el-table-column>

                <!-- 操作列 -->
                <el-table-column label="操作" header-align="center" align="center">
                    <template v-slot="scope">
                        <div style="display: flex">
                            <!-- <el-button type="danger" @click="handleDelete(scope.row.idString)">
                                删除
                            </el-button> -->
                            <!-- <el-button @click="managerSetting(scope.row)" style="margin-left: 12px"> -->
                            <el-button @click="getexcel(scope.row)" type="success" style="margin-left: 12px"> 导出
                            </el-button>
                            <el-button @click="gettaskList(scope.row)" style="margin-left: 12px"> 刷新 </el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 页码栏 -->
            <div style="display: flex; justify-content: center">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="itemsPerPage"
                    layout="total, sizes, prev, pager, next, jumper" :total="allitems">
                </el-pagination>
            </div>
        </div>
        <!-- 弹窗 -->
        <div>
            <!-- 各人进度 -->
            <el-dialog v-model="personcondListDialogShow" title="审核员审核进度" draggable>
                <!-- 总情况 -->
                <div v-for="process in personcondList" :key="process" style="margin-bottom: 12px">
                    <div class="name" style="margin-bottom: 8px">
                        {{ process.nickName }} 总数: {{ process.totalCount }}
                        || 已审核:
                        {{ process.hasFinishCount }} || 待审核: {{ process.remainCount }}
                    </div>
                    <div class="jindu">
                        <el-progress :percentage="noNaN(process.hasFinishCount, process.totalCount)" />
                    </div>
                </div>
                <!-- 分情况 -->
                <div style="display: flex; justify-content: space-between">
                    <el-radio-group v-model="viewtype">
                        <el-radio value="all">总分配</el-radio>
                        <el-radio value="finish">已审核</el-radio>
                        <el-radio value="uncheck">未审核</el-radio>
                        <el-radio value="successbuy">出价成功</el-radio>
                    </el-radio-group>
                    <el-button link @click="updategetpersondetail()" type="primary" size="large">
                        <el-icon>
                            <RefreshRight />
                        </el-icon>
                        刷新
                    </el-button>
                </div>
                <!-- 重新分配 -->
                <el-button link @click="againAssign()" type="primary" size="large"
                    style="margin: 10px 0">重新分配</el-button>
                <el-dialog title="重新分配" v-model="againAssignDialog" class="again">
                    <el-form :model="againAssignFrom">
                        <el-form-item label="任务名称" :label-width="formLabelWidth">
                            <el-input disabled v-model="againAssignFrom.taskName" autocomplete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="任务批次" :label-width="formLabelWidth">
                            <el-input disabled v-model="againAssignFrom.patch" autocomplete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="结束出价" :label-width="formLabelWidth">
                            <el-select v-model="againAssignFrom.fromReallocateUser" multiple placeholder="请选择被分配人">
                                <el-option v-for="item in fromReallocateUser" :key="item.loginId" :label="item.nickName"
                                    :value="item.loginId" />
                            </el-select>
                        </el-form-item>
                        <el-form-item label="分配给谁" :label-width="formLabelWidth">
                            <el-select v-model="againAssignFrom.toReallocateUser" multiple placeholder="请选择分配给谁">
                                <el-option v-for="item in toReallocateUser" :key="item.loginId" :label="item.nickName"
                                    :value="item.loginId" />
                            </el-select>
                        </el-form-item>
                        <el-form-item label="平台" :label-width="formLabelWidth">
                            <el-select v-model="againAssignFrom.sourceList" multiple placeholder="请选择平台">
                                <el-option v-for="item in sourcesLsit" :key="item.id" :label="item.platformName"
                                    :value="item.platformName" />
                            </el-select>
                        </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="againAssignDialog = false">取 消</el-button>
                        <el-button type="primary" @click="againAssignHandle">确 定</el-button>
                    </div>
                </el-dialog>
                <!-- 数据 -->
                <el-table :data="personcondList" show-summary :summary-method="summaryMethod">
                    <!-- 姓名 -->
                    <el-table-column label="姓名" property="nickName"> </el-table-column>

                    <!-- 各人各平台全部 -->
                    <el-table-column v-for="(item, index) in platformnameList" :key="index" :label="item">
                        <template #default="scope">
                            {{ getPlatformCount(scope.row, item) }}
                        </template>
                    </el-table-column>

                    <!-- 个人总计 -->
                    <el-table-column label="个人总计">
                        <template #default="scope">
                            {{ getpersoncount(scope.row) }}
                        </template>
                    </el-table-column>

                    <!-- 审过百分比 -->
                    <!--  -->
                    <el-table-column label="审核通过率" v-if="viewtype == 'successbuy'">
                        <!--/{{ passnobuyrate(scope.row) }}  -->
                        <template #default="scope">{{ passnobuyrate(scope.row) }} </template>
                    </el-table-column>
                </el-table>
            </el-dialog>

            <!-- 查价格弹窗 -->
            <el-dialog v-model="CalculatedataDialogShow" title="相关数据查询" :close-on-click-modal="false">
                <!-- 动态更新的进度条 -->
                <div style="margin-bottom: 10px" v-show="true">
                    符合条件总数:<el-progress :text-inside="true" :stroke-width="26" :percentage="progress1"></el-progress>
                    成色判断:<el-progress :text-inside="true" :stroke-width="26" :percentage="progress2"
                        status="success"></el-progress>
                    转转估价:<el-progress :text-inside="true" :stroke-width="26" :percentage="progress3" status="warning">
                    </el-progress> 拍机堂估价:<el-progress :text-inside="true" :stroke-width="26" :percentage="progress4"
                        status="exception">
                    </el-progress>
                </div>
                <div v-if="allProgressComplete">
                    <br />
                    <!-- <el-button type="primary" @click="exitTask">完成 !</el-button> -->
                    <!-- <el-button type="" @click="exitTask"> 刷新 </el-button>
                    <el-button type="info" @click="exitTask">后台继续计算</el-button> -->
                    <el-table :data="[CalculatedataList]" style="width: 100%">
                        <el-table-column prop="totalWarePriceCount" label="符合条件总数" width="180" />
                        <el-table-column prop="totalConditionCount" label="成色判断数" width="180" />
                        <el-table-column prop="totalSystemEvaCount" label="已有转转价格数" />
                        <el-table-column prop="totalPjtEvaluateDescCount" label="拍机堂价格数" />
                    </el-table>
                </div>
                <template #footer v-if="allProgressComplete">
                    <div class="dialog-footer" style="display: flex; justify-content: center">
                        <el-button @click="exitTask">关闭</el-button>
                    </div>
                </template>
            </el-dialog>
        </div>
    </div>
</template>
<script>
import { debounce } from "@/utils/untilTwo";
import axios from "axios";

export default {
    name: "taskconditionView",
    data() {
        return {
            getexcelURL: "/api/biddingTask/exportExcel",

            updategetpersondetailList: [],
            // 查看模式
            viewtype: "all",

            // 任务包含的平台名称列表
            platformnameList: [],

            tempplatformList: [],
            sourcesLsit: [],
            // 查询平台
            getPlatFormURL: "/api/systemPlatformInfo/platForm/init",

            // 进度条
            progress1: 0,
            progress2: 0,
            progress3: 0,
            progress4: 0,
            intervalId: null,

            personcondListDialogShow: false,
            CalculatedataDialogShow: false,
            CalculatedataList: [],
            personcondList: [],

            getCalculatedataURL: "/api/biddingTask/searchProgress",
            getpersondetailURL: "/api/biddingTask/getAllOperatorBiddingTaskCompleteInfoByTaskId",
            detailURL: "/api//biddingTask/getAllOperatorBiddingTaskCompleteInfoByTaskId/",
            gettaskListURL: "/api/biddingTask/getBiddingTaskCompleteInfoByPage",
            againAssignURL: "/api/taskInfo/taskReallocate",
            formData: {
                taskName: "",
                patch: "",
                platform: "",
            },

            currentPage: 1,
            itemsPerPage: 10,
            allitems: 1,

            managerList: [],
            againAssignDialog: false,
            taskName: "",
            againAssignFrom: {
                taskName: "",
                taskId: "",
                patch: "",
                fromReallocateUser: [],
                toReallocateUser: [],
                sourceList: [],
            },
            formLabelWidth: "120px",
            fromReallocateUser: [], //被分配人
            toReallocateUser: [], //分配人
        };
    },
    methods: {
        noNaN(a, b) {
            if (isNaN(a) || isNaN(b) || b === 0) {
                return 0; // 防止除以零，或者如果输入无效则返回 0
            }
            return parseFloat(((a / b) * 100).toFixed(2));
        },

        //审过百分比
        passnobuyrate(row) {
            if (row.hasFinishCount && row.hasFinishCount > 0) {
                return ((row.successCount / row.hasFinishCount) * 100).toFixed(2) + "%";
            } else {
                return "未审核";
            }
        },

        async getexcel(row) {
            try {
                const response = await axios.get("/api/biddingTask/exportExcel", {
                    headers: {
                        satoken: localStorage.sa,
                    },
                    params: {
                        taskId: row.id,
                        platform: "",
                        patch: row.patch,
                    },
                    responseType: "blob", // 设置响应类型为 blob
                });

                const blob = response.data;

                const url = window.URL.createObjectURL(blob);

                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", row.taskName); // 设置下载文件名
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            } catch (error) {
                console.error("Error downloading file:", error);
            }
        },

        // 下载excel
        // getexcel(row) {

        //     axios.get(this.getexcelURL, {
        //         headers: {
        //             satoken: localStorage.sa,
        //         },
        //         params: {
        //             taskId: row.id,
        //             platform: '',
        //             patch: row.patch,
        //         },
        //     })
        //     .then(response => response.blob())
        //     .then(blob => {
        //         // 处理文件流数据
        //         handleFileDownload(blob);
        //     })
        // },

        handleFileDownload(blob) {
            // 创建临时 URL
            const url = URL.createObjectURL(blob);

            // 创建一个模拟点击链接的方式触发下载
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "filename.ext"); // 设置下载文件名
            document.body.appendChild(link);
            link.click();

            // 释放临时 URL
            URL.revokeObjectURL(url);
        },

        // 个人统计
        getpersoncount(row) {
            if (this.viewtype == "all") {
                return row.totalCount;
            } else if (this.viewtype == "finish") {
                return row.hasFinishCount;
            } else if (this.viewtype == "uncheck") {
                return row.remainCount;
            } else if (this.viewtype == "successbuy") {
                return row.successCount;
            }
        },

        // 平台统计
        getPlatformCount(row, platform) {
            let platformData = [];
            if (this.viewtype == "all") {
                platformData = row.platformCount.find((eer) => eer.platform === platform);
            } else if (this.viewtype == "finish") {
                platformData = row.platformHasFinishCount.find((eer) => eer.platform === platform);
            } else if (this.viewtype == "uncheck") {
                platformData = row.platformRemainCount.find((eer) => eer.platform === platform);
            } else if (this.viewtype == "successbuy") {
                platformData = row.successBiddingCount.find((eer) => eer.platform === platform);
            }

            return platformData ? platformData.count : 0;
        },

        // 汇总方法，计算每列的汇总值
        summaryMethod({ columns, data }) {
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums.push("总计");
                } else {
                    const sum = data.reduce((acc, row) => {
                        const count = this.getPlatformCount(row, column.label);
                        return acc + count;
                    }, 0);
                    sums.push(sum);
                }
                if (column.label == "审核通过率") {
                    sums[sums.length - 1] = "-";
                }
            });

            sums[sums.length - 2] = sums.slice(1, sums.length - 1).reduce((a, b) => a + b, 0);

            return sums;
        },

        // 获取平台列表
        getAllPlatformList() {
            axios
                .get(this.getPlatFormURL, {
                    headers: {
                        satoken: localStorage.sa,
                    },
                    params: {
                        ...this.formData,
                    },
                })
                .then((res) => {
                    if (res.data.success) {
                        this.sourcesLsit = res.data.data;
                    }
                });

            // getPlatFormURL,
        },
        exitTask() {
            this.CalculatedataDialogShow = false;
        },
        // 进度条
        startProgress() {
            // 如果已有定时器，先清除它
            if (this.intervalId) {
                clearInterval(this.intervalId);
            }

            // 设置一个定时器来动态更新进度条
            this.intervalId = setInterval(() => {
                // 依次更新每个进度条的进度
                // if (this.progress1 < 100) this.progress1 += 3;
                // if (this.progress2 < 100) this.progress2 += 4;
                // if (this.progress3 < 100) this.progress3 += 6;
                // if (this.progress3 > 100) this.progress3 += -2;
                // if (this.progress2 > 100) this.progress2 += -1;
                // if (this.progress1 > 100) this.progress1 += -2;
                // if (this.progress4 < 100) this.progress4 += 3;
                // if (this.progress4 > 100) this.progress4 += -4;

                this.progress1 = 100;
                this.progress2 = 100;
                this.progress3 = 100;
                this.progress4 = 100;

                // 当所有进度条完成时，清除定时器
                if (this.progress1 >= 100 && this.progress2 >= 100 && this.progress3 >= 100 && this.progress4 >= 100) {
                    clearInterval(this.intervalId);
                }
            }, 50); // 每100ms更新一次进度
        },

        // 价格计算进度
        getCalculatedata(taskid, patch) {
            this.CalculatedataDialogShow = true;
            axios
                .get(this.getCalculatedataURL, {
                    headers: {
                        satoken: localStorage.sa,
                    },
                    params: {
                        taskId: taskid,
                        patch: patch,
                    },
                })
                .then((res) => {
                    if (res.data.success) {
                        this.CalculatedataList = res.data.data;
                        // this.CalculatedataDialogShow = true
                    }
                });
        },

        // 弹窗页面刷新
        updategetpersondetail() {
            this.getpersondetail(this.updategetpersondetailList[0], this.updategetpersondetailList[1]);
        },
        //重新分配
        againAssign() {
            this.againAssignDialog = true;
        },
        // 重新分配提交
        againAssignHandle: debounce(function () {
            let params = {};
            params.taskId = this.againAssignFrom.taskId;
            params.patch = this.againAssignFrom.patch;
            params.fromReallocateUser = this.againAssignFrom.fromReallocateUser;
            params.toReallocateUser = this.againAssignFrom.toReallocateUser;
            params.sourceList = this.againAssignFrom.sourceList;
            axios
                .post(this.againAssignURL, params, {
                    headers: {
                        satoken: localStorage.sa,
                    },
                })
                .then((res) => {
                    if (res.data.success) {
                        this.$message({
                            showClose: true,
                            message: "重新分配成功",
                            type: "success",
                        });
                        this.againAssignDialog = false;
                    } else {
                        this.$message.error(res.data.message);
                    }
                });
        }),

        // 各人情况
        getpersondetail(taskid, platformnameListStr, row) {
            // taskName:'',
            // againAssignFrom: {
            //     taskId: '',
            //     patch: '',
            //     fromReallocateUser: [],
            //     toReallocateUser: [],
            //     sourceList: []
            // },
            this.againAssignFrom.taskName ? (this.againAssignFrom.taskName = this.againAssignFrom.taskName) : (this.againAssignFrom.taskName = row.taskName);
            this.againAssignFrom.taskId ? (this.againAssignFrom.taskId = this.againAssignFrom.taskId) : (this.againAssignFrom.taskId = row.id);
            this.againAssignFrom.patch ? (this.againAssignFrom.patch = this.againAssignFrom.patch) : (this.againAssignFrom.patch = row.patch);
            // this.againAssignFrom.taskName = row.taskName;
            // this.againAssignFrom.taskId = row.id;
            // this.againAssignFrom.patch = row.patch;
            this.updategetpersondetailList = [taskid, platformnameListStr];

            this.platformnameList = platformnameListStr.split(",");
            axios
                .get(this.getpersondetailURL + "/" + taskid, {
                    headers: {
                        satoken: localStorage.sa,
                    },
                })
                .then((res) => {
                    if (res.data.success) {
                        this.fromReallocateUser = res.data.data;
                        this.toReallocateUser = res.data.data;
                        this.personcondList = res.data.data.map((item) => {
                            if (typeof item.value === "string") {
                                // 或者使用 Number(item.value)
                                item.value = parseFloat(item.value);
                            }
                            return item;
                        });
                        this.personcondListDialogShow = true;
                    }
                });
        },

        // 平台名称展示为图片
        platformList(string) {
            // 将传入的字符串按逗号分割成数组
            let tem = string.split(",");
            tem.sort();
            let res = [];

            // 遍历数组，根据平台名称推入对应的图片路径
            for (let i = 0; i < tem.length; i++) {
                if (tem[i] === "采货侠") {
                    res.push(require("@/assets/images/chx.png"));
                } else if (tem[i] === "回收宝") {
                    res.push(require("@/assets/images/hsb.jpg"));
                } else if (tem[i] === "小当竞拍") {
                    res.push(require("@/assets/images/xd.png"));
                } else if (tem[i] === "拍机堂") {
                    res.push(require("@/assets/images/pjt.png"));
                }
            }
            // 返回结果数组
            return res;
        },

        handleSizeChange(val) {
            this.itemsPerPage = val;
            this.currentPage = 1;
            this.gettaskList();
        },

        handleCurrentChange(val) {
            this.currentPage = val;
            this.gettaskList();
        },

        // 管理员查看任务列表
        gettaskList() {
            this.formData.platform = this.tempplatformList.join(",");
            axios
                .get(this.gettaskListURL + "/" + this.currentPage + "/" + this.itemsPerPage, {
                    headers: {
                        satoken: localStorage.sa,
                    },
                    params: {
                        ...this.formData,
                    },
                })
                .then((res) => {
                    if (res.data.success) {
                        this.managerList = res.data.data.result;
                        this.allitems = res.data.data.total;
                    }
                });
        },
    },
    watch: {
        // 当弹窗显示时，启动进度条
        CalculatedataDialogShow(newVal) {
            if (newVal) {
                // 重置进度条
                this.progress1 = 0;
                this.progress2 = 0;
                this.progress3 = 0;
                this.progress4 = 0;

                // 启动进度条更新
                this.startProgress();
            }
        },
    },
    computed: {
        // 计算是否所有进度条都已完成
        allProgressComplete() {
            return this.progress1 >= 100 && this.progress2 >= 100 && this.progress3 >= 100 && this.progress4 >= 100;
        },
    },
    created() {
        this.gettaskList();
        this.getAllPlatformList();
    },
};
</script>
<style lang="scss" scoped>
/* 表格样式*/
:deep(.el-table) {
    border-radius: 12px;
    justify-content: center;
    --el-table-header-bg-color: rgb(107, 107, 107);
    --el-table-text-color: #000000;
    --el-table-border: 1px solid #ebeef5;
}

.el-form-item {
    margin-bottom: 0;
}

:deep(.el-input.el-input--default.el-input--suffix) {
    // 固定宽度
    width: 200px !important;
}

.again .el-form-item {
    margin-bottom: 20px;
    width: 400px;
}
</style>
